import { QueryClientProvider, type QueryClient } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { createBrowserRouter, RouterProvider } from "react-router";
import { AnnouncerProvider } from "../shared/components/Announcer";
import { ToastProvider } from "../shared/components/Toast";
import { createQueryClient } from "./queryClient";
import { routes } from "./routes";

const queryClient = createQueryClient();
const router = createBrowserRouter(routes);

export function AppProviders({ client, children }: { client: QueryClient; children: ReactNode }) {
  return (
    <QueryClientProvider client={client}>
      <AnnouncerProvider>
        <ToastProvider>{children}</ToastProvider>
      </AnnouncerProvider>
    </QueryClientProvider>
  );
}

export function App() {
  return (
    <AppProviders client={queryClient}>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
